import React, { useContext, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Badge } from '@mui/material'
import { useLocation } from 'react-router-dom'
import { BadgeContext } from 'src/context/MentorContext/BadgeContext'
import { badgeCountFor, MENTOR_BADGE_MAP } from 'src/Common/notificationBadges'

const DynamicBadge = ({ dataKey, name, variant }) => {
  const { badgeData, fetchBadgeData } = useContext(BadgeContext)
  const location = useLocation()

  useEffect(() => {
    fetchBadgeData()
  }, [dataKey, location, fetchBadgeData])

  useEffect(() => {
    const handleBadgeUpdate = () => fetchBadgeData()
    window.updateBadgeCount = handleBadgeUpdate
    return () => {
      window.updateBadgeCount = null
    }
  }, [])

  const badgeCount = badgeCountFor(badgeData, dataKey, MENTOR_BADGE_MAP)

  // CSS class dynamically select karega
  const containerClass = variant === 'alternate' ? 'alternate-badge' : 'default-badge'
  const badgeClass = variant === 'alternate' ? 'alternate-badge-style' : 'default-badge-style'

  return (
    <div className={containerClass}>
      <span>{name}</span>
      {badgeCount > 0 && <Badge badgeContent={badgeCount} color="error" className={badgeClass} />}
    </div>
  )
}

DynamicBadge.propTypes = {
  // essayReviewApplicationId removed: no caller passes it and the component never uses it,
  // so it logged an undefined required-prop warning on every render.
  dataKey: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  variant: PropTypes.oneOf(['default', 'alternate']),
}

export default DynamicBadge
